import { useTosaUserFeature } from '../../../hooks/useTosaUserFeature';
import { FeatureName, AcAltGetStartedPageTreatments } from '../../../utils';

import type { UseFeatureHook } from '../../../types';

interface UseAltGetStartedPageExperimentArgs {
  useFeature: UseFeatureHook;
  couponCode?: string;
}

export interface UseAltGetStartedPageExperimentReturn {
  isAltGetStartedPageExperimentOn: boolean;
  treatment: keyof typeof AcAltGetStartedPageTreatments;
}

export function useAltGetStartedPageExperiment({
  useFeature,
  couponCode,
}: UseAltGetStartedPageExperimentArgs): UseAltGetStartedPageExperimentReturn {
  const { treatment } = useTosaUserFeature({
    useFeature,
    featureName: FeatureName.AC_ALT_GET_STARTED_PAGE,
    ...(couponCode ? { attributes: { couponCode } } : {}),
  });

  if (
    treatment == AcAltGetStartedPageTreatments.portions_and_price ||
    treatment == AcAltGetStartedPageTreatments.personalized_nutrition
  ) {
    return { isAltGetStartedPageExperimentOn: true, treatment };
  }

  return {
    isAltGetStartedPageExperimentOn: false,
    treatment: AcAltGetStartedPageTreatments.off,
  };
}
